import script from "./ConnectionUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectionUpdate.vue?vue&type=script&setup=true&lang=js"

import "./ConnectionUpdate.vue?vue&type=style&index=0&id=e43dbd8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e43dbd8c"]])

export default __exports__